<template>
  <validable-form @submit="submit">
    <modal background>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ edit ? "Edytuj biuro" : "Dodaj nowe biuro" }}
          </p>
          <button
            class="delete"
            type="submit"
            aria-label="close"
            @click="cancel"
          ></button>
        </header>

        <section class="modal-card-body">
          <div class="form">
            <label class="label">Nazwa biura</label>
            <div class="field">
              <div class="control has-icons has-icons-left">
                <control-input
                  rules="required"
                  type="text"
                  placeholder="Punkt obsługi..."
                  v-model.trim="office.name"
                />
                <icon class="is-small is-left" name="fa-tag" />
              </div>
            </div>

            <label class="label">Adres</label>
            <div class="field">
              <div class="control has-icons has-icons-left">
                <control-input
                  rules="required"
                  type="text"
                  placeholder="Ulica, nr lokalu..."
                  v-model.trim="office.address"
                />
                <icon class="is-small is-left" name="fa-map-marker-alt" />
              </div>
            </div>
            <div class="field">
              <div class="control has-icons has-icons-left">
                <control-input
                  rules="required"
                  type="text"
                  placeholder="Kod pocztowy, miejscowość..."
                  v-model.trim="office.city"
                />
                <icon class="is-small is-left" name="fa-map-marker-alt" />
              </div>
            </div>

            <label class="label">Dni robocze</label>
            <div class="field">
              <div class="control has-icons has-icons-left">
                <control-input
                  rules="required"
                  type="text"
                  placeholder="pn. - pt."
                  v-model.trim="office.days"
                />
                <icon class="is-small is-left" name="fa-calendar-alt" />
              </div>
            </div>

            <label class="label">Godziny otwarcia</label>
            <div class="field">
              <div class="control has-icons has-icons-left">
                <control-input
                  rules="required"
                  type="text"
                  placeholder="8:00 - 16:00"
                  v-model.trim="office.hours"
                />
                <icon class="is-small is-left" name="fa-clock" />
              </div>
            </div>

            <label class="label">Uwagi</label>
            <div class="field">
              <div class="control">
                <textarea
                  class="textarea"
                  placeholder="Dodatkowe uwagi dotyczące np. godzin pracy biura..."
                  v-model.trim="office.disclaimer"
                />
              </div>
            </div>

            <label class="label">Adresy e-mail</label>
            <div
              class="field has-addons"
              v-for="(mail, index) in office.mails"
              :key="`mail${index}`"
            >
              <div class="control has-icons has-icons-left is-expanded">
                <control-input
                  ref="mail"
                  rules="required"
                  type="text"
                  placeholder="Adres e-mail..."
                  v-model.trim="office.mails[index]"
                  @blur="removeMailIfEmpty(index)"
                />
                <icon class="is-small is-left" name="fa-at" />
              </div>
              <div class="control">
                <button
                  type="button"
                  class="button is-danger"
                  @click="removeMail(index)"
                >
                  <icon name="fa-times" />
                </button>
              </div>
            </div>
            <div class="field is-pulled-right">
              <button type="button" class="button is-primary" @click="addMail">
                <icon name="fa-plus" />
              </button>
            </div>

            <div class="is-clearfix" />

            <label class="label">Numery telefonu</label>
            <div
              class="field has-addons"
              v-for="(phone, index) in office.phones"
              :key="`phone${index}`"
            >
              <div class="control has-icons has-icons-left is-expanded">
                <control-input
                  ref="phone"
                  rules="required"
                  type="text"
                  placeholder="123 456 789"
                  v-model.trim="office.phones[index]"
                  @blur="removePhoneIfEmpty(index)"
                />
                <icon class="is-small is-left" name="fa-phone-alt" />
              </div>
              <div class="control">
                <button
                  type="button"
                  class="button is-danger"
                  @click="removePhone(index)"
                >
                  <icon name="fa-times" />
                </button>
              </div>
            </div>
            <div class="field is-pulled-right">
              <button type="button" class="button is-primary" @click="addPhone">
                <icon name="fa-plus" />
              </button>
            </div>

            <div class="is-clearfix" />

            <label class="label">Lokalizacja</label>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control has-icons has-icons-left">
                    <control-input
                      type="text"
                      rules="required|decimal|min_value:-90|max_value:90"
                      placeholder="Szerokość geograficzna"
                      v-model.trim="office.point[0]"
                    />
                    <icon class="is-small is-left" name="fa-map" />
                  </div>
                </div>
                <div class="field">
                  <div class="control has-icons has-icons-left">
                    <control-input
                      rules="required|decimal|min_value:-180|max_value:180"
                      type="text"
                      placeholder="Długość geograficzna"
                      v-model.trim="office.point[1]"
                    />
                    <icon class="is-small is-left" name="fa-map" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <button class="button is-success" type="submit">
            <icon name="fa-check" />
            <span>Akceptuj</span>
          </button>
          <button class="button" type="button" @click="cancel">Anuluj</button>
        </footer>
      </div>
    </modal>
  </validable-form>
</template>

<script>
import { Modal } from "%modals";
import { Icon, ValidableForm, ControlInput } from "%helpers";

export default {
  name: "office-modal",

  components: {
    Modal,
    Icon,
    ValidableForm,
    ControlInput
  },

  props: {
    value: {
      type: Object,
      default: () => ({
        name: "",
        address: "",
        city: "",
        days: "",
        hours: "",
        disclaimer: "",
        phones: [],
        mails: [],
        point: []
      })
    },

    onSave: Function,

    edit: Boolean
  },

  data() {
    return {
      office: {}
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.office = {
        ...this.value,
        phones: [...this.value.phones],
        mails: [...this.value.mails],
        point: [...this.value.point]
      };
    },

    async addPhone() {
      this.office.phones.push("");
      await this.$nextTick();
      this.$refs.phone[this.office.phones.length - 1].focus();
    },

    removePhone(index) {
      this.office.phones.splice(index, 1);
    },

    removePhoneIfEmpty(index) {
      if (this.office.phones[index].trim().length === 0) {
        this.removePhone(index);
      }
    },

    async addMail() {
      this.office.mails.push("");
      await this.$nextTick();
      this.$refs.mail[this.office.mails.length - 1].focus();
    },

    removeMail(index) {
      this.office.mails.splice(index, 1);
    },

    removeMailIfEmpty(index) {
      if (this.office.mails[index].trim().length === 0) {
        this.removeMail(index);
      }
    },

    submit() {
      this.onSave(this.office);
      this.cancel();
    },

    cancel() {
      this.$emit("hide");
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  padding-bottom: 1rem;
}
</style>
